import { Box } from '@mui/material';
import axios from 'axios';
import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

const SERVER = process.env.REACT_APP_SERVER;

function PaymentSuccess() {
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const paymentKey = params.get('paymentKey');
    const orderId = params.get('orderId');
    const amount = params.get('amount');
    const { apId } = useParams();

    useEffect(() => {
        if (paymentKey && orderId && amount) {
            axios
                .post(`${SERVER}/api/payments/verify`, {
                    paymentKey: paymentKey,
                    orderId: orderId,
                    amount: amount,
                    applicationId: apId,
                })
                .then((res) => {
                    console.log(res.data.message);
                    alert('결제가 완료되었습니다.');
                    navigate('/lecture', { state: { email: res.data.customerEmail } });
                })
                .catch((error) => {
                    if (
                        error.data &&
                        error.data.code === 'FAILED_PAYMENT_INTERNAL_SYSTEM_PROCESSING'
                    ) {
                        alert('이미 결제가 처리 중입니다. 잠시 후 다시 시도해 주세요.');
                    }
                });
        } else {
            alert('결제 실패. 내정보에서 다시 시도 해주세요.');
            navigate('/lecture');
        }
    }, [paymentKey, orderId, amount]);

    return <Box sx={{ minHeight: '70vh' }}></Box>;
}

export default PaymentSuccess;
